import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {useI18n} from "@/i18n/I18nProvider"
const orangeBorder = "1px solid #F18222";
const transparentBorder = "1px solid transparent"

const FeedbackEmoj = ({ question, options, onSelect, value }) => {
  const { t, locale } = useI18n();

  const items = options || t.feedback.defaultOptions;
 

  const handleSelect = (id) => {
    if (onSelect) onSelect(id);
  };

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", my: 2 }}>
      {question && (
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "12px",
            lineHeight: "24px",
            direction: locale === "ar" ? "rtl" : "ltr",
            color: "#000814",
            pr: "7px",
          }}
        >
          {question}
        </Typography>
      )}

      <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", direction: t.direction,}}>
        {items.map((item) => (
          <Box
            key={item.id}
            onClick={() => handleSelect(item.id)}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
              flex: 1,
            }}
          >
            {/*Box contain Emoj or Text */}
            <Box
              sx={{
                width: { xs: "50px", sm: "50px" },
                height: { xs: "40px", sm: "45px" },
                borderRadius: "12px",
                backgroundColor: "#F8F8F8",
                border:
                   item.src
                    ? (String(value) === String(item.id) ? orangeBorder : transparentBorder)
                    : ((item.id === 1 ? true : false) === value) ? orangeBorder : transparentBorder,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "transform 0.2s ease, border 0.2s ease",
                transform: value === item.id ? "scale(1.05)" : "scale(1)",
              }}
            >
              {item.src ? (
                <img
                  src={item.src}
                  alt={item.text}
                  style={{
                    width: "22px",
                    height: "22px",
                  }}
                />
              ) : (
                <Typography
                  sx={{
                    fontSize: { xs: "14px", sm: "16px" },
                    fontWeight: 600,
                    color: "#000814",
                  }}
                >
                  {item.text}
                </Typography>
              )}
            </Box>

            {/*text under Emoj*/}
            {item.src && (
              <Typography
                sx={{
                  fontSize: { xs: "11px", sm: "12px" },
                  fontWeight: 400,
                  color: "#545A62",
                  textAlign: "center",
                }}
              >
                {item.text} 
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default FeedbackEmoj;
